module.exports = __webpack_public_path__ + "static/media/Analytics_reporting.a4c7340a.png";